<template>
  <div>
  <div class="about">
    <h2>联系我们</h2>
    <p>如果您有任何问题或建议，请随时联系：bragg_chen@163.com。</p>
  </div>
  <div class="about">
    <h2>关于本项目</h2>
    <p>这是一个使用 <strong>Vue 2.7</strong> 搭建的基础 Dashboard 项目。</p>
    <ul class="features">
      <li>✅ Vue 2.7（含 Composition API 回移）</li>
      <li>✅ Vue Router 3（hash 模式）</li>
      <li>✅ Vuex 3（状态管理）</li>
      <li>✅ @vue/cli-service 5（基于 Webpack 5 的构建工具链）</li>
      <li>
        ✅ 本项目基于开源技术datav实现
        <br />
        <br />
        <pre>
The MIT License (MIT)

Copyright (c) 2018-present, DataV-Team

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
        </pre>
      </li>
    </ul>
  </div>

  </div>
  
</template>

<script>
export default {
  name: 'AboutView'
}
</script>

<style scoped>
.about h2 {
  margin-bottom: 16px;
  color: #303133;
}

.about p {
  color: #606266;
  line-height: 1.8;
  margin-bottom: 16px;
}

.features {
  list-style: none;
  padding: 0;
}

.features li {
  padding: 10px 14px;
  background: #f9fafc;
  border-radius: 6px;
  margin-bottom: 8px;
  color: #606266;
}
</style>
